export const MIN_ON_TEXT_INPUT = 2;
export const MAX_ON_TEXT_INPUT = 255;
export const MIN_ON_PASSWORD_INPUT = 8;
export const MAX_COMMENT_LENGTH = 199;
export const MAX_TEXTAREA_LENGTH = 1000;
export const MAX_TEXT_LENGTH = 65000;
export const MAX_DESCRIPTION_LENGTH = 65535;
export const YEAR_LENGTH = 4
export const ACTIVE_STATUS = 'Active';
export const INACTIVE_STATUS = 'Inactive';
export const STATUS_LIST = [
  { id: '1', title: ACTIVE_STATUS },
  { id: '0', title: INACTIVE_STATUS },
];

